const map = {
	"./daylight.css": [
		7000,
		[
			0
		]
	],
	"./forest.css": [
		7149,
		[
			149
		]
	],
	"./obsidian.css": [
		2021,
		[
			21
		]
	],
	"./ocean.css": [
		8298,
		[
			298
		]
	],
	"./sunset.css": [
		8400,
		[
			400
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1284;
module.exports = webpackAsyncContext;